import {Component} from '@angular/core';
import {DatePipe} from "@angular/common";
import {Dialog} from '../../../../interfaces/dialog/dialog';
import {News} from '../../../../models/news';
import {ImageService} from '../../../../services/image/image.service';
import {DialogParams} from '../../../../interfaces/dialog/dialog-params';

@Component({
  selector: 'app-news',
  imports: [
    DatePipe,
  ],
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss'
})
export class NewsComponent implements Dialog {
  news!: News;

  constructor(
    protected imageService: ImageService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.news = params.data;
  }
}
